export default __webpack_public_path__ + "static/media/Skup Pula (9).82740e20.jpg";